module.exports = __webpack_public_path__ + "static/media/logo-pacsci.72f93b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/clientlogos/logo-pacsci.png
// module id = 552
// module chunks = 0